module.exports = __webpack_public_path__ + "static/media/headphone.02929d66.svg";